import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { User } from './type';
import { UserRepository } from './repository';

export const useUsers = defineStore('users', () => {

    const userRepository = new UserRepository();
    const loggedUser = ref<User | null>(null)

    const login = async (credentials: { email: string, password: string }) => {
        const res = await userRepository.login(credentials)
        loggedUser.value = res.data
        return res
    }

    const logout = async () => {
        const res = await userRepository.logout();
        if (!res.error) {
            loggedUser.value = null;
            window.location.href = '/';
        }
    }

    const getUser = async () => {
        const res = await userRepository.getUser()
        loggedUser.value = res.data.user
        return res
    }

    return {
        loggedUser,
        login,
        logout,
        getUser,
    }

}, {
    persist: {
        pick: ['loggedUser'],
    },
})